<ng-template #template>
  <div class="modal-header">
    <button type="button" (click)="bsModalRef.hide()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    <h4 class="pull-left modal-title">{{ titulo }}</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-xs-12">
        <h4>{{ mensagem }}</h4>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="showFecharBtn" type="button" class="btn btn-border-orange pull-left" data-dismiss="modal" (click)="bsModalRef.hide()">{{ labelFechar }}</button>
    <button *ngIf="showOkBtn" type="button" class="btn btn-full-orange pull-right" (click)="bsModalRef.hide()" data-dismiss="modal">{{ labelOk }}</button>
  </div>
</ng-template>
